<script>
  /**
   * The current value of the input field.
   * @type {string}
   * @default ''
   * @export
   */
  export let value = '';

  /**
   * The input field DOM element reference.
   * @type {Object}
   * @default null
   * @export
   */
  export let ref = null;

  /**
   * The disabled state of the input field.
   * @type {boolean}
   * @default null
   * @export
   */
  export let disabled = null;

  /**
   * The regular expression pattern used for validation.
   * @type {string}
   * @default null
   * @export
   */
  export let pattern = null;

  /**
   * The validation status based on the pattern and input value.
   * @type {boolean}
   * @default true if pattern is null
   */
  export let valid = pattern === null;

  /**
   * Regular expression object created from the provided pattern.
   * @type {RegExp}
   */
  const regexp = new RegExp(pattern);

  /**
   * Watches the 'pattern' and 'value' variables and updates 'valid' accordingly.
   * @type {boolean}
   */
  $: valid = pattern ? regexp.test(value) : true;
</script>

<textarea
  bind:this={ref}
  aria-disabled={disabled}
  on:input
  on:change
  on:focus
  on:blur
  on:keyup
  on:keypress
  on:keydown
  bind:value
  {disabled}
  {valid}
  {...$$props}
/>

<style lang="scss" src="./textarea.scss"></style>
